// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, update, create, get } from "./operations.js";
export type {
  TableListOptionalParams,
  TableDeleteOptionalParams,
  TableUpdateOptionalParams,
  TableCreateOptionalParams,
  TableGetOptionalParams,
} from "./options.js";
